"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _expressChangeReceive = _interopRequireDefault(require("@/views/rsManagement/expressOrderList/components/expressChangeReceive.vue"));
var _expressOrderSend = _interopRequireDefault(require("@/views/rsManagement/expressOrderList/components/expressOrderSend.vue"));
var _orderDetail = _interopRequireDefault(require("@/views/rsManagement/expressOrderList/components/orderDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ExpressOrderIndex',
  components: {
    OrderDetail: _orderDetail.default,
    OrderSend: _expressOrderSend.default,
    ChangeReceive: _expressChangeReceive.default
  },
  data: function data() {
    return {
      loading: false,
      exportLoading: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        orderNo: '',
        outTradeNo: '',
        orderStatus: null,
        receiverKeyword: '',
        storeType: null
      },
      storeTypeOptions: [],
      orderStatusOptions: [{
        label: '已取消',
        value: 0
      }, {
        label: '待支付',
        value: 1
      }, {
        label: '已支付',
        value: 2
      }, {
        label: '已发货',
        value: 4
      }, {
        label: '已完结',
        value: 6
      }, {
        label: '退款成功',
        value: 8
      }, {
        label: '支付失败',
        value: 12
      }]
    };
  },
  created: function created() {
    this.fetchList();
    this.fetchStoreTypeOptions();
  },
  methods: {
    fetchStoreTypeOptions: function () {
      var _fetchStoreTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _rsManagement.getMerchantStoreTypeList)();
            case 1:
              res = _context.v;
              this.storeTypeOptions = (res || []).filter(function (item) {
                return Number(item.type) === 1;
              });
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取店铺类型失败：', _t);
              this.storeTypeOptions = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchStoreTypeOptions() {
        return _fetchStoreTypeOptions.apply(this, arguments);
      }
      return fetchStoreTypeOptions;
    }(),
    // 退款
    _refund: function () {
      var _refund2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return this.$confirm("\u786E\u5B9A\u8981\u5BF9\u8BA2\u5355 ".concat(row.orderNo, " \u6267\u884C\u9000\u6B3E\u64CD\u4F5C\u5417\uFF1F\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002"), '退款确认', {
                confirmButtonText: '确认退款',
                cancelButtonText: '再想想',
                type: 'warning',
                confirmButtonClass: 'el-button--danger',
                center: true
              });
            case 1:
              _context2.n = 2;
              return (0, _rsManagement.refund)(row.orderNo);
            case 2:
              this.$message.success("\u8BA2\u5355 ".concat(row.orderNo, " \u9000\u6B3E\u6210\u529F"));
              this.fetchList();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              if (_t2 === 'cancel') {
                this.$message.info('已取消退款操作');
              } else {
                console.error('退款失败：', _t2);
                this.$message.error('退款失败：' + (_t2.message || '未知错误'));
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function _refund(_x) {
        return _refund2.apply(this, arguments);
      }
      return _refund;
    }(),
    handerSearch: function handerSearch() {
      // 是否刷新
      // 获取列表数据
      this.fetchList();
    },
    //订单发货
    sendOrder: function sendOrder(orderNo) {
      this.$refs['OrderSendRef'].openInit({
        orderNo: orderNo
      });
    },
    // 修改收货地址
    updateReceive: function updateReceive(orderNo) {
      this.$refs['ChangeReceiveRef'].openInit(orderNo);
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.fetchList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.query.page = val;
      this.fetchList();
    },
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      (0, _rsManagement.getExpressAdminList)(this.query).then(function (res) {
        _this.list = res.list || [];
        _this.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.query.page = 1;
      this.fetchList();
    },
    exportOrders: function () {
      var _exportOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.exportLoading = true;
              _context3.n = 1;
              return (0, _rsManagement.exportMerchantExpressOrderList)(this.query);
            case 1:
              res = _context3.v;
              if (!(res && res.fileName)) {
                _context3.n = 2;
                break;
              }
              window.open(res.fileName);
              this.$message.success('开始导出');
              return _context3.a(2);
            case 2:
              this.$message.error('导出失败，未获取到下载地址');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.error('导出快递订单失败：', _t3);
              this.$message.error('导出失败：' + (_t3.message || '未知错误'));
            case 4:
              _context3.p = 4;
              this.exportLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3, 4, 5]]);
      }));
      function exportOrders() {
        return _exportOrders.apply(this, arguments);
      }
      return exportOrders;
    }(),
    handleReset: function handleReset() {
      this.query = {
        page: 1,
        limit: 10,
        orderNo: '',
        outTradeNo: '',
        orderStatus: null,
        receiverKeyword: '',
        storeType: null
      };
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.query.page = page;
      this.fetchList();
    },
    handleView: function handleView(row) {
      this.$refs['OrderDetailRef'].openDetail(row.orderNo);
    },
    // 获取订单状态类型
    getOrderStatusType: function getOrderStatusType(status) {
      var statusMap = {
        0: 'danger',
        // 已取消
        1: 'warning',
        // 待支付
        2: 'primary',
        // 已支付
        3: 'warning',
        // 处理中
        4: 'primary',
        // 已发货
        5: 'success',
        // 已签收
        6: 'success',
        // 已完结

        7: 'warning',
        // 退款中
        8: 'success',
        // 退款成功
        9: 'danger',
        // 退款失败
        10: 'danger',
        // 拒绝退款

        11: 'danger',
        // 已关闭
        12: 'danger',
        // 支付失败
        13: 'danger',
        // 向第三方下单失败

        14: 'warning',
        // 部分退款
        15: 'info',
        // 售后中
        16: 'warning',
        // 部分发货

        71: 'warning' // 待退款
      };
      return statusMap[status] || 'info';
    },
    getDeliveryStatusType: function getDeliveryStatusType(status) {
      var statusMap = new Map([[-2, 'info'], [-1, 'info'], [1, 'primary'], [0, 'primary'], [5, 'primary'], [3, 'success'], [6, 'danger'], [4, 'danger'], [14, 'danger'], [7, 'warning'], [2, 'warning'], [8, 'warning']]);
      return statusMap.get(status) || 'info';
    }
  }
};